// extracted by mini-css-extract-plugin
export default {"submenu":"Submenu_submenu__ajo22","submenuRight":"Submenu_submenuRight__gtMbJ"};